import React, { useState } from 'react'
import { makeStyles } from '@material-ui/core/styles'
import { useSelector } from 'react-redux'
import { Box, Typography } from '@material-ui/core'
import HotSwapWelcome from './hot-swap-welcome'
import HotSwapDashboard from './hot-swap-dashboard'

const useStyles = makeStyles(theme => ({
    wrapper: {
        display: 'flex',
        flexDirection: 'column',
        height: '100%'
    },
    headingSection: {
        display: 'flex',
        flexDirection: 'column',
        justifyContent: 'center',
        alignItems: 'center',
        width: '70%',
        textAlign: 'center',
        margin: '0 auto',
        padding: '12px 0'
    },
    heading: { fontSize: '2.35rem', lineHeight: '46px', fontWeight: 600 },
    text: { fontSize: '1rem', lineHeight: '23.4px' },
    link: {
        color: theme.primary,
        textDecoration: 'none',
        fontWeight: 'bold',
        fontSize: 24
    }
}))

export default function HotSwap() {
    const { locale, theme } = useSelector(state => state.main)
    const classes = useStyles()
    const [hasVisitedWelcomePage, setHasVisitedWelcomePage] = useState(true)
    return (
        <div className={classes.wrapper}>
            <Box className={classes.headingSection}>
                <Typography className={classes.heading}>
                    {locale.hotSwap.hotSwap}
                </Typography>
                <Typography className={classes.text}>
                    <div>{locale.hotSwap.description}</div>
                    <div
                        style={{
                            marginTop: 10,
                            marginBottom: 10,
                            padding: 10,
                            borderRadius: theme.borderRadius,
                            border: `2px solid ${theme.warning}`,
                            backgroundColor: `${theme.warning}10`,
                            fontWeight: 'bold'
                        }}>
                        {locale.hotSwap.capacityIssueMessage}
                    </div>
                    {hasVisitedWelcomePage ? (
                        <>
                            <br />
                            <a
                                style={{ marginTop: 10 }}
                                className={classes.link}
                                target="_blank"
                                href="https://www.youtube.com/embed/nHA9DafWbBk"
                                rel="noreferrer">
                                {` ${locale.hotSwap.introVideo}`}
                            </a>
                        </>
                    ) : (
                        ''
                    )}
                </Typography>
            </Box>
            {hasVisitedWelcomePage ? (
                <HotSwapDashboard />
            ) : (
                <HotSwapWelcome setHasVisited={setHasVisitedWelcomePage} />
            )}
        </div>
    )
}
